module.exports = __webpack_public_path__ + "img/ic_user_active.3386a9ee.svg";